import React from 'react';
import { parseISO } from 'date-fns';
import { formatDate } from '../../../helpers/dates';
import { stepWorkday } from '../../../helpers/desk-booking';
import type { DeskBookingRange } from '../../../types';

type Props = {
  date: string,
  today: string,
  range: DeskBookingRange,
  onDateChange: (date: string) => void,
  actions?: React.ReactNode,
};

const DateNav = (props: Props): React.ReactElement => {
  const {
    date, today, range, onDateChange, actions,
  } = props;
  const previous = stepWorkday(date, -1, range);
  const next = stepWorkday(date, 1, range);

  return (
    <div className="desk-date-nav">
      <button type="button" className="btn btn-link desk-date-nav__step" aria-label="Previous day" disabled={previous === date} onClick={() => onDateChange(previous)}>
        ←
      </button>
      <button type="button" className="btn btn-link desk-date-nav__step" disabled={date === today} onClick={() => onDateChange(today)}>
        Today
      </button>
      <button type="button" className="btn btn-link desk-date-nav__step" aria-label="Next day" disabled={next === date} onClick={() => onDateChange(next)}>
        →
      </button>
      <strong className="desk-date-nav__label">{formatDate(parseISO(date), 'EEEE, dd.MM.yyyy')}</strong>
      <input
        type="date"
        className="form-control desk-date-nav__input"
        aria-label="Pick a day"
        value={date}
        min={range.from}
        max={range.to}
        onChange={(event) => {
          if (event.target.value) onDateChange(event.target.value);
        }}
      />
      {actions}
    </div>
  );
};

export default DateNav;
